module.exports = __webpack_public_path__ + "img/darkblue_line.f8719b99.png";